// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrapper[data-v-bf4795dc]{transition-duration:.15s}.wrapper__checkbox[data-v-bf4795dc]{--tw-border-opacity:1;--tw-text-opacity:1;align-items:center;border-color:#f1832f;border-color:rgb(241 131 47/var(--tw-border-opacity));border-radius:.25rem;border-width:2px;color:#fff;color:rgb(255 255 255/var(--tw-text-opacity));display:flex;font-weight:700;height:1.25rem;justify-content:center;line-height:1;width:1.25rem}.wrapper[data-v-bf4795dc]:hover{opacity:.75}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
